import React from 'react';
import { graphql, navigate } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { fontSize, fontWeights, standardColours } from '../styles';
import { Link } from './ui';
import { buildUrl } from '../utils';

const StyledMegaMenuCta = styled.article`
  cursor: pointer;
`;

const StyledImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 20px;
  border: 1px solid ${standardColours.lightGrey};
  aspect-ratio: 1/1;
`;

const StyledHeading = styled.h3`
  margin-top: 12px;
  font-weight: ${fontWeights.medium};
  ${fontSize(16)};
  text-align: center;
`;

const MegaMenuCta = ({ image, heading, slug, ...props }) =>
  image && (
    <StyledMegaMenuCta onClick={() => navigate(buildUrl(slug))} {...props}>
      <StyledImageWrapper>
        <GatsbyImage image={image.gatsbyImageData} alt={image.alt} />
      </StyledImageWrapper>
      <StyledHeading>
        <Link to={slug}>{heading}</Link>
      </StyledHeading>
    </StyledMegaMenuCta>
  );

export default MegaMenuCta;

export const MegaMenuCtaFragment = graphql`
  fragment MegaMenuCtaFragment on Node {
    ... on DatoCmsPage {
      heading: title
      slug
      image: featuredImage {
        alt
        gatsbyImageData(width: 140, imgixParams: { w: "140" })
      }
      ...LinkFragment
    }
    ... on DatoCmsProductCategory {
      heading: title
      slug: shopifyCollection
      image: featuredImage {
        alt
        gatsbyImageData(width: 140, imgixParams: { w: "140" })
      }
    }
  }
`;
